var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view--tiles"},[_c('tile-list',{attrs:{"show-add-button":false,"show-bulk-actions":true,"show-filters":{ 'category': true, 'created_at': true, 'updated_at': true, 'search': true },"show-paging":true,"show-sort":true,"show-thumbnail-slider":false,"show-title":false}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c141ada","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/tiles/Index.vue
// module id = oZy0
// module chunks = 0